import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DataService } from '../../../core/data.service';

@Component({
  standalone: false,
  selector: 'app-favorite-icon',
  templateUrl: './favorite-icon.component.html',
  styleUrls: ['./favorite-icon.component.scss']
})
export class FavoriteIconComponent {
  @Input() favoriteId = '';
  @Input() favoriteType = '';
  @Input() status = 0;
  // Named `statusChange` so callers can use Angular's two-way `[(status)]` sugar —
  // that way mutating `status` here flows back to the bound row property
  // (e.g. q.is_favorite), keeping the session caches consistent automatically.
  @Output() statusChange = new EventEmitter<number>();

  toggling = false;

  constructor(private dataSvc: DataService) {}

  toggle(): void {
    if (this.toggling) return;
    const prev = this.status;
    const next = prev === 1 ? 0 : 1;
    // Optimistic flip — UI updates immediately; revert below if the call fails.
    this.status = next;
    this.statusChange.emit(next);
    this.toggling = true;
    const action = prev === 1 ? 'FavoriteRemove' : 'FavoriteAdd';
    this.dataSvc.dgGet([{
      action,
      returnas: '',
      FavoriteID: this.favoriteId,
      FavoriteType: this.favoriteType
    }]).subscribe({
      next: () => { this.toggling = false; },
      error: () => {
        this.status = prev;
        this.statusChange.emit(prev);
        this.toggling = false;
      }
    });
  }
}
